module.exports = __webpack_public_path__ + "static/media/cvg_background.6213a577.png";